var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"/","aria-label":"Home"}},[(!_vm.isLoadingLogo)?_c('img',{staticClass:"logo rounded",class:{ loading: _vm.isLoading },attrs:{"src":_vm.brandLogoUrl,"alt":"OrchestratorBot"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }